export interface UninstallAppState {
  modalOpen: boolean
}

export const initialState: UninstallAppState = {
  modalOpen: false
}
